import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Booking from "./pages/Booking";
import Services from "./pages/Services";
import Scores from "./pages/Scores";
import Pricing from "./pages/Pricing";
import AppDev from "./pages/AppDev";
import BlueLedger from "./pages/BlueLedger";
import FAQs from "./pages/FAQs";
import Contact from "./pages/Contact";
import MyBooking from "./pages/MyBooking";
import PaymentResult from "./pages/PaymentResult";
import CertifiedCopy from "./pages/CertifiedCopy";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/services" element={<Services />} />
            <Route path="/scores" element={<Scores />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/app-development" element={<AppDev />} />
            <Route path="/blue-ledger" element={<BlueLedger />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/my-booking" element={<MyBooking />} />
            <Route path="/payment-result" element={<PaymentResult />} />
            <Route path="/certified-copy" element={<CertifiedCopy />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
